export const mapAbilityIcon = (ability) => {
  let iconType: string;
  switch (ability.toLowerCase()) {
    case 'battery':
      iconType = 'battery';
      break;
    case 'status':
      iconType = 'status';
      break;
    case 'battery change':
      iconType = 'battery';
      break;
    case 'hours':
      iconType = 'speed';
      break;
    case 'orientation':
      iconType = 'orientation';
      break;
    case 'location':
      iconType = 'location';
      break;
    case 'temperature':
      iconType = 'temperature';
      break;
    case 'humidity':
      iconType = 'humidity';
      break;
    case 'barometric pressure':
      iconType = 'pressure';
      break;
    case 'vibration':
      iconType = 'vibration';
      break;
    case 'frequency':
      iconType = 'analytics';
      break;
    case 'voltage':
      iconType = 'voltage';
      break;
    case 'spo2':
      iconType = 'analytics';
      break;
    case 'weight':
      iconType = 'analytics';
      break;
    case 'blood pressure':
      iconType = 'pressure';
      break;
    case 'ecg':
      iconType = 'status';
      break;
    case 'heart rate':
      iconType = 'status';
      break;
    case 'systolic':
      iconType = 'analytics';
      break;
    case 'diastolic':
      iconType = 'analytics';
      break;
    case 'moisture':
      iconType = 'humidity';
      break;
    case 'light':
      iconType = 'lightbulb';
      break;
    case 'tamper':
      iconType = 'analytics';
      break;
    case 'amperage':
      iconType = 'power';
      break;
    case 'power':
      iconType = 'power';
      break;
    case 'power consumption':
      iconType = 'power';
      break;
    case 'power factor':
      iconType = 'power';
      break;
    case 'pressure differential':
      iconType = 'pressure';
      break;
    case 'health check':
      iconType = 'heart';
      break;
    case 'fault':
      return (
        <i
          className={`sonarIcon sonarIcon-circle-add sonarIcon-rotate-45 fs-2x primary-icon align-sub`}
        />
      );
    default:
      iconType = 'analytics'; // fallback
      break;
  }

  return <i className={`sonarIcon sonarIcon-${iconType} fs-2x primary-icon align-sub`} />;
};
